package io.horion.auth.presentation.ui.components.auth

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.*
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.icons.fa.*
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import io.horion.auth.domain.models.AuthState
import io.horion.auth.presentation.ui.styles.BannerStyle
import io.horion.auth.presentation.ui.theme.AuthTheme
import io.horion.auth.presentation.ui.theme.AuthTypography
import org.jetbrains.compose.web.css.*

@Composable
fun VerificationBanner() {
    val ctx = rememberPageContext()
    val colorMode = ColorMode.current
    val colors = AuthTheme.colors(colorMode)
    val user = AuthState.currentUser
    var isDismissed by remember { mutableStateOf(false) }

    if (user == null || user.isVerified || isDismissed) return

    Box(
        modifier = BannerStyle.toModifier()
            .styleModifier { property("background-color", "rgba(245, 158, 11, 0.08)") }
            .border(1.px, LineStyle.Solid, colors.warning)
    ) {
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.CenterVertically
        ) {
            Row(verticalAlignment = Alignment.CenterVertically, modifier = Modifier.gap(12.px)) {
                FaTriangleExclamation(modifier = Modifier.fontSize(18.px).color(colors.warning))
                Column(modifier = Modifier.gap(2.px)) {
                    SpanText(
                        "Compte non vérifié",
                        modifier = Modifier.fontSize(AuthTypography.small).fontWeight(FontWeight.SemiBold).color(colors.onBackground)
                    )
                    SpanText(
                        "Vérifie ton ${if (user.email != null) "e-mail" else "téléphone"} pour accéder à toutes les fonctionnalités",
                        modifier = Modifier.fontSize(AuthTypography.tiny).color(colors.mutedText)
                    )
                }
            }

            Row(verticalAlignment = Alignment.CenterVertically, modifier = Modifier.gap(8.px)) {
                Box(
                    modifier = Modifier
                        .padding(leftRight = 10.px, topBottom = 6.px)
                        .borderRadius(6.px)
                        .backgroundColor(colors.warning)
                        .cursor(Cursor.Pointer)
                        .onClick { ctx.router.navigateTo("/send-otp") },
                    contentAlignment = Alignment.Center
                ) {
                    SpanText(
                        "Vérifier",
                        modifier = Modifier.fontSize(AuthTypography.tiny).fontWeight(FontWeight.SemiBold).color(Colors.White)
                    )
                }
                Box(
                    modifier = Modifier.size(28.px).borderRadius(50.percent).cursor(Cursor.Pointer).onClick { isDismissed = true },
                    contentAlignment = Alignment.Center
                ) {
                    FaXmark(modifier = Modifier.fontSize(14.px).color(colors.mutedText))
                }
            }
        }
    }
}